import Model from './model'

export default class Message extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/message'
    }
}
